<template>
  <ElDialog
    :visible="value"
    :title="$t('ADVERTISEMENT.ADD_BID')"
    width="40%"
    append-to-body
    @close="closeAndReset"
  >
    <div>
      <ElForm
        ref="bidForm"
        :model="bidModel"
        :rules="bidRules"
        label-position="right"
        @submit.native.prevent="addBid"
      >
        <ElFormItem prop="query" :label="$t('ADVERTISEMENT.BID.KEYWORD')">
          <AddKeywordInput
            :matching-type.sync="bidModel.matchingType"
            :query.sync="bidModel.query"
            name="query"
            required
          />
        </ElFormItem>
        <BidsSuggestions @add="addSuggestion" />
        <ElFormItem prop="priceOffer" :label="$t('ADVERTISEMENT.BID.MAX_CPI')">
          <ElInput
            v-model.number="bidModel.priceOffer"
            type="number"
            name="priceOffer"
            required
          />
        </ElFormItem>
      </ElForm>
      <div slot="footer" class="dialog-footer">
        <ElButton
          type="primary"
          native-type="submit"
          size="large"
          :loading="isLoading"
          @click.native="addBid"
        >
          {{ $t('ADVERTISEMENT.ADD_BID_BTN') }}
        </ElButton>
      </div>
    </div>
  </ElDialog>
</template>

<script>
import BidsSuggestions from './BidsSuggestions';

import { ADD_CAMPAIGN_BID } from '@/store/types';

import campaignId from '@/mixins/advertisement/campaignId';
import form from '@/mixins/form';

import required from '@/utils/validation-rules/required';

import AddKeywordInput from '@@/advertisement/common/AddKeywordInput';

import { matchingTypes } from '@@/advertisement/common/constants';

import { AD_CAMPAIGN_ADD_KEYWORD_STATE, STATE } from '@/constants/gtm-events';

export default {
  name: 'AddBidModal',

  components: {
    BidsSuggestions,
    AddKeywordInput,
  },

  mixins: [campaignId, form],

  props: {
    value: Boolean,
  },

  data() {
    return {
      isLoading: false,
      bidModel: {
        query: '',
        priceOffer: 0,
        matchingType: matchingTypes[0].property,
        fromSuggestions: false,
      },
    };
  },
  computed: {
    bidRules() {
      const requiredRule = required(this.$t('VALIDATION_REQUIRED_ERR'));

      return {
        query: required(this.$t('VALIDATION_REQUIRED_ERR')),
        priceOffer: requiredRule,
      };
    },
  },

  methods: {
    addBid() {
      if (!this.isValid('bidForm')) {
        return false;
      }
      this.isLoading = true;

      return this.$store
        .dispatch(ADD_CAMPAIGN_BID, {
          campaignId: this.campaignId,
          bid: this.bidModel,
        })
        .then(message => {
          this.$message.success(message);

          this.$gtm.trackEvent(AD_CAMPAIGN_ADD_KEYWORD_STATE(STATE.SUCCESS));

          this.closeAndReset();
        })
        .catch(({ message }) => {
          if (message) {
            this.$message.error(message);
          }

          this.$gtm.trackEvent(AD_CAMPAIGN_ADD_KEYWORD_STATE(STATE.FAIL));
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    closeAndReset() {
      this.resetForm('bidForm');
      this.bidModel.fromSuggestions = false;

      this.$emit('input', false);
    },

    addSuggestion(suggestion) {
      this.bidModel.query = suggestion;
      this.bidModel.fromSuggestions = true;
    },
  },
};
</script>
